import { ORG_PRODUCTS_TAB_FR_FR } from "./products-tab";
import { ORG_PRODUCTS_CATEGORIES_FR_FR } from "./categories";
import { OrgProductsTranslations } from "#i18n/translations/pt-BR/org/products";

export const ORG_PRODUCTS_FR_FR: OrgProductsTranslations = {
	tabs: {
		productsTab: ORG_PRODUCTS_TAB_FR_FR,
		categories: ORG_PRODUCTS_CATEGORIES_FR_FR,
		generalStock: "Stock général",
	},
	functions: {
		modal: {
			sheet: {
				inventory: "inventaire",
				columns: {
					id: "Id du produit",
					name: "Nom",
					category: "Catégorie",
					type: "Type de produit",
					hasAlcohol: "Contient-il de l'alcool ?",
					fiscalCode: "SKU",
					fiscalNcm: "Fiscal - NCM",
				},
			},
		},
	},
	emptyList: "Aucun produit trouvé",
};
